export default "__VITE_ASSET__c$nfFo1w__"